import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { get } from "../../services/httpClient";
import { PatientMessageTemplate } from "core/types/index";

const getMessageTemplate = async (patientUserId: number) => {
  const res = await get<{ data: PatientMessageTemplate[] }>(
    `psychologist/message/template/${patientUserId}`,
  );
  return res.data;
};

const getPatientMessageTemplatesQueryKey = (patientUserId: number) => [
  "patientMessageTemplates",
  patientUserId,
];

type MessageTemplateItem = {
  label: string;
  title: string;
  value: number;
  body: string;
  templateType: string;
};

export const useGetPatientMessageTemplates = (
  patientUserId: number | undefined,
) => {
  return useQuery({
    queryKey: getPatientMessageTemplatesQueryKey(patientUserId ?? 0),
    queryFn: () =>
      patientUserId ? getMessageTemplate(patientUserId) : Promise.resolve([]),
    staleTime: Infinity,
    enabled: !!patientUserId && patientUserId > 0,
    select(data) {
      return data.map<MessageTemplateItem>((item, i) => {
        return {
          label: item.shortDescription,
          title: item.title,
          value: i,
          body: item.body,
          templateType: item.templateType,
        };
      });
    },
  });
};
